export interface TimelineThreadCandidate {
  narrativeThreads?: string[];
}

/**
 * Timeline consumes canonical narrative membership from the backend classifier.
 * Keeping keyword semantics out of the view prevents a second rule engine from
 * drifting away from the persisted classification contract.
 */
export function itemMatchesTimelineThread(
  item: TimelineThreadCandidate,
  slug: string,
): boolean {
  if (slug === "all") return true;
  return item.narrativeThreads?.includes(slug) ?? false;
}
